import { render, staticRenderFns } from "./SearchInputs.vue?vue&type=template&id=3b3326f0&scoped=true"
import script from "./SearchInputs.vue?vue&type=script&lang=js"
export * from "./SearchInputs.vue?vue&type=script&lang=js"
import style0 from "./SearchInputs.vue?vue&type=style&index=0&id=3b3326f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3326f0",
  null
  
)

export default component.exports